import iconsPng from '@/assets/img/png/icons';
import svgIcons from '@/assets/svg/icons';
import CustomButton from '@/components/atoms/CustomButton';
import { FORM_FIELD_WIDTH, SUPPORT_TEAM_CARD_HEIGHT, SUPPORT_TEAM_CARD_WIDTH } from '@/constants/dimensions';
import { useAuthContext } from '@/context/auth/useAuthContext';
import useNotifyOrgAdminsAboutMissingPeerSupport from '@/hooks/user/useNotifyOrgAdminsAboutMissingPeerSupport';
import colors from '@/theme/colors';
import { Card, HStack, Image, Text, VStack } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import React, { useState } from 'react';

const NoPeerSupportMemberCard = () => {
  const { isAdmin } = useAuthContext();
  const navigate = useNavigate();

  const [hasClickedNotify, setHasClickedNotify] = useState(false);

  const { mutate: notifyOrgAdminsAboutMissingPeerSupport, isPending } = useNotifyOrgAdminsAboutMissingPeerSupport(() =>
    setHasClickedNotify(true),
  );

  return (
    <VStack width={'100%'} alignItems={'center'}>
      <Card
        size="sm"
        width={SUPPORT_TEAM_CARD_WIDTH}
        height={SUPPORT_TEAM_CARD_HEIGHT}
        variant={'elevated'}
        borderRadius={'8px'}
        padding={'20px'}
        shadow={'0px 0px 20px 0px rgba(0, 65, 121, 0.15)'}
      >
        <HStack
          width="100%"
          paddingBottom={'20px'}
          gap={'20px'}
          justifyContent={'center'}
          marginTop={'30px'}
          marginBottom={'10px'}
        >
          <Image alt="add-member" src={iconsPng.handshake} width={100} height={100} />
        </HStack>

        <VStack width={'100%'} height={'100%'} justifyContent={'space-between'} marginBottom={'20px'}>
          <VStack>
            <Text variant={'loraMedium18'} color={'text.mediumGray'} marginY={'24px'}>
              Peer Support has not Been Added
            </Text>
            <Text variant={'urbanistBold16'} color={'text.mediumBlue'} marginBottom={'8px'}>
              What is this, actually?
            </Text>
            <Text variant={'urbanistSemiBoldRegular'} color={'text.mediumBlue'} textAlign={'center'} paddingX={'10px'}>
              A co-worker support model based off lived experience, that equips trustworthy peers with skills to support
              their co-workers and respond to crisis.
            </Text>
          </VStack>

          <CustomButton
            backgroundColor={colors.extra.white}
            labelColor={colors.primary[500]}
            labelHoverColor={colors.extra.white}
            iconBeforeLabelSvgPath={isAdmin ? svgIcons.users : hasClickedNotify ? svgIcons.check : svgIcons.bell}
            iconBeforeLabelSvgSize={isAdmin ? 18 : hasClickedNotify ? 12 : undefined}
            iconBeforeLabelSvgBoxWidth={isAdmin ? 20 : hasClickedNotify ? undefined : 24}
            iconBeforeLabelSvgBoxHeight={isAdmin ? 20 : hasClickedNotify ? undefined : 24}
            iconBeforeLabelSvgColor={colors.primary[500]}
            label={
              isAdmin
                ? 'Go to Roster'
                : hasClickedNotify
                  ? 'Organization Admin has been notified'
                  : 'Notify Your Organization Admin'
            }
            hoverBackgroundColor="primary.500"
            borderColor={colors.primary[500]}
            borderHoverColor={colors.primary[500]}
            onClick={() => {
              if (isAdmin) {
                navigate({ to: '/organization/roster' });
              } else {
                notifyOrgAdminsAboutMissingPeerSupport();
              }
            }}
            width={FORM_FIELD_WIDTH}
            disabled={hasClickedNotify}
            isLoading={isPending}
            noShadow
          />
        </VStack>
      </Card>
    </VStack>
  );
};

export default NoPeerSupportMemberCard;
